import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { provideLoaders } from '@frontend/loaders';
import { AppComponent, bootloader, provideVanillaCore } from '@frontend/vanilla/core';

import { appRoutes } from './app.routes';
import { provideMokaBingo } from './provide';

if (process.env.NODE_ENV === 'production') {
    enableProdMode();
}

bootloader().then(() => {
    bootstrapApplication(AppComponent, {
        providers: [provideRouter(appRoutes), provideAnimations(), provideVanillaCore(), provideLoaders(), provideMokaBingo()],
    })
        // eslint-disable-next-line no-console
        .catch((err) => console.error(err));
});
